import { render, staticRenderFns } from "./navbar_green.vue?vue&type=template&id=68ff4c24&scoped=true&"
import script from "./navbar_green.vue?vue&type=script&lang=js&"
export * from "./navbar_green.vue?vue&type=script&lang=js&"
import style0 from "./navbar_green.vue?vue&type=style&index=0&id=68ff4c24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ff4c24",
  null
  
)

export default component.exports